/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取优惠劵列表信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  coupon: good.CouponDetailsCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<good.CouponDetailDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/good/coupon-details`,
    data: coupon,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
